// ═══════════════════════════════════════════════════════════════════
//  composants/styles.js
//  Styles en ligne réutilisés par plusieurs modules.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export const btnBack={ background:"transparent",border:`1px solid ${THEME.border}`,color:THEME.textMuted,borderRadius:6,padding:"6px 12px",cursor:"pointer",fontSize:13 };

export const btnGhost={ background:"transparent",border:`1px solid ${THEME.border}`,color:THEME.textMuted,borderRadius:8,padding:"9px 18px",cursor:"pointer",fontSize:13 };

export const btnPrimary={ background:THEME.purpleDim,border:`1px solid ${THEME.purple}`,color:THEME.purple,borderRadius:8,padding:"9px 18px",cursor:"pointer",fontSize:13,fontWeight:700 };

export const iconBtn={ background:"transparent",border:"none",cursor:"pointer",fontSize:13,padding:2 };

// Cartes empilées sur mobile (CDC Lot 3 — tableaux -> cartes)
export const cardBox={ background:THEME.panel,border:`1px solid ${THEME.border}`,borderRadius:12,padding:"12px 14px",marginBottom:10 };

export const cardLabel={ color:THEME.textMuted,fontSize:11,textTransform:"uppercase",letterSpacing:0.5,flexShrink:0 };

export const inp={ background:THEME.surface,border:`1px solid ${THEME.border}`,color:THEME.text,borderRadius:8,padding:"8px 10px",fontSize:13,width:"100%",boxSizing:"border-box" };

export const modalOverlay={ position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20 };

export const modalBox={ background:THEME.surface,border:`1px solid ${THEME.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:620,maxHeight:"90vh",overflowY:"auto" };
